var Associativity;
(function (Associativity) {
    Associativity[Associativity["Left"] = 0] = "Left";
    Associativity[Associativity["Right"] = 1] = "Right";
})(Associativity || (Associativity = {}));
var Precedence;
(function (Precedence) {
    Precedence[Precedence["Or"] = 0] = "Or";
    Precedence[Precedence["And"] = 1] = "And";
    Precedence[Precedence["Not"] = 2] = "Not";
    Precedence[Precedence["Identity"] = 3] = "Identity";
    Precedence[Precedence["Comparison"] = 4] = "Comparison";
    Precedence[Precedence["Containment"] = 5] = "Containment";
    Precedence[Precedence["Additive"] = 6] = "Additive";
    Precedence[Precedence["Multiplicative"] = 7] = "Multiplicative";
    Precedence[Precedence["Unary"] = 8] = "Unary";
    Precedence[Precedence["Primary"] = 9] = "Primary";
    Precedence[Precedence["Highest"] = 9] = "Highest";
    Precedence[Precedence["Lowest"] = 0] = "Lowest";
})(Precedence || (Precedence = {}));
function getExprAssociativity(node) {
    switch (node.type) {
        case "UNARY":
            return 1;
        case "BINARY":
        case "LOGICAL": {
            return getBinaryOperatorAssociativity(node.operator);
        }
        default: {
            return 0;
        }
    }
}
function getExprPrecedence(node) {
    switch (node.type) {
        case "UNARY": {
            return node.operator === 'NOT' ? 2 : 8;
        }
        case "BINARY":
        case "LOGICAL": {
            return getBinaryOperatorPrecedence(node.operator);
        }
        case "ACCESS":
        case "IDENT":
        case "PARAM":
        case "CALL_NAME":
        case "LIST_LITERAL":
        case "NULL_LITERAL":
        case "BOOLEAN_LITERAL":
        case "NUMBER_LITERAL":
        case "STRING_LITERAL":
        case "REGEXP_LITERAL":
        case "DATE_TIME_LITERAL":
        case "CALL":
        case "CAST":
        case "CASE":
        case "CASE_COND":
        case "CASE_ELSE":
        case "IF_COND":
        case "IF_ELSE": {
            return 9;
        }
    }
}
function getBinaryOperatorAssociativity(operator) {
    switch (operator) {
        default: {
            return 0;
        }
    }
}
function getBinaryOperatorPrecedence(operator) {
    switch (operator) {
        case 'OR': {
            return 0;
        }
        case 'AND': {
            return 1;
        }
        case 'IS':
        case 'IS NOT':
        case 'IS DISTINCT FROM':
        case 'IS NOT DISTINCT FROM': {
            return 3;
        }
        case '=':
        case '<>':
        case '>=':
        case '<=':
        case '>':
        case '<': {
            return 4;
        }
        case 'IN':
        case 'NOT IN': {
            return 5;
        }
        case '+':
        case '-': {
            return 6;
        }
        case '*':
        case '/':
        case '%': {
            return 7;
        }
    }
}
export function shouldParenthesizeBinaryLeft(node) {
    switch (node.type) {
        case "BINARY":
        case "LOGICAL": {
            return binaryOperandNeedsParens(node.operator, node.left, true);
        }
        default: {
            return false;
        }
    }
}
export function shouldParenthesizeBinaryRight(node) {
    switch (node.type) {
        case "BINARY":
        case "LOGICAL": {
            return binaryOperandNeedsParens(node.operator, node.right, false);
        }
        default: {
            return false;
        }
    }
}
export function binaryOperandNeedsParens(operator, operand, isLeft) {
    const operatorPrecedence = getBinaryOperatorPrecedence(operator);
    const operandPrecedence = getExprPrecedence(operand);
    if (operandPrecedence === 4 &&
        operatorPrecedence === 4) {
        return true;
    }
    if (operandPrecedence < operatorPrecedence) {
        return true;
    }
    if (operandPrecedence > operatorPrecedence) {
        return false;
    }
    if (isLeft) {
        const operatorAssociativity = getBinaryOperatorAssociativity(operator);
        return operatorAssociativity === 1;
    }
    if (operand.type === "LOGICAL") {
        return operand.operator !== operator;
    }
    if (operand.type === "BINARY" && operand.operator === operator) {
        if (operatorHasAssociativeProperty(operator)) {
            return false;
        }
    }
    const operandAssociativity = getExprAssociativity(operand);
    return operandAssociativity === 0;
}
function operatorHasAssociativeProperty(operator) {
    switch (operator) {
        case '+':
        case '*': {
            return true;
        }
        default: {
            return false;
        }
    }
}
